import { PRISMIC_TYPES } from '~/lib/prismic-types'
import { SHOPIFY_TYPES } from '~/lib/shopify/constants'

import i18n from '~/utils/i18n'

import { GENERAL } from '~/data/dictionary'

export default function getPageNameFromPrismicType(type) {
  switch (type) {
    case PRISMIC_TYPES.CATEGORY_FASHION_V2:
    case PRISMIC_TYPES.ROOT_CATEGORY_FASHION_V2:
      return i18n.t(GENERAL.CATEGORY_FASHION_PAGE)
    case PRISMIC_TYPES.CATEGORY_FRAGRANCE_V2:
    case PRISMIC_TYPES.ROOT_CATEGORY_FRAGRANCE_V2:
      return i18n.t(GENERAL.CATEGORY_FRAGRANCE_PAGE)
    case PRISMIC_TYPES.BLOG:
      return i18n.t(GENERAL.BLOG)
    case PRISMIC_TYPES.CONTACT:
      return i18n.t(GENERAL.CONTACT)
    case PRISMIC_TYPES.ERROR_PAGE:
      return i18n.t(GENERAL.ERROR)
    case PRISMIC_TYPES.FAQ:
      return i18n.t(GENERAL.FAQ_PAGE)
    case PRISMIC_TYPES.PRODUCT_FASHION_V2:
    case SHOPIFY_TYPES.PRODUCT_FASHION:
      return i18n.t(GENERAL.PRODUCT_FASHION_PAGE)
    case PRISMIC_TYPES.PRODUCT_FRAGRANCE_V2:
    case SHOPIFY_TYPES.PRODUCT_FRAGRANCE:
      return i18n.t(GENERAL.PRODUCT_FRAGRANCE_PAGE)
    case PRISMIC_TYPES.PRODUCT_SETS:
      return i18n.t(GENERAL.PRODUCT_SET_PAGE)
    case PRISMIC_TYPES.SEARCH:
      return i18n.t(GENERAL.SEARCH)
    case PRISMIC_TYPES.STORE_LOCATOR:
      return i18n.t(GENERAL.STORE_LOCATOR)
    default:
      return null
  }
}
